import React, { createContext, PropsWithChildren } from "react";

import { FlashPromotion } from "~/entities/flashPromotionEntities";

/**
 * The flash promotion for the current site and order type, or null.
 *
 * At most one: two live countdowns competing for the same customer would be
 * absurd. Targeting, scheduling and whether the code will actually redeem here
 * are all decided server side.
 */
const FlashPromotionContext = createContext<{
  flashPromotion: FlashPromotion | null;
}>({
  flashPromotion: null,
});

type FlashPromotionContextProviderProps = {
  flashPromotion: FlashPromotion | null;
};

export const FlashPromotionContextProvider: React.FC<
  PropsWithChildren<FlashPromotionContextProviderProps>
> = ({ flashPromotion, children }) => (
  <FlashPromotionContext.Provider value={{ flashPromotion }}>
    {children}
  </FlashPromotionContext.Provider>
);

export default FlashPromotionContext;
